export default "__VITE_ASSET__CIX0Np9___"